import { configure } from 'mobx'
import { useEffect, useState } from 'react'
import './zoomstyles.css'
import MediaPermissionsChecker from './MediaPermissionsChecker'
import RoleBasedCSS from './RoleBasedCSS'
import WaitingRoomObserver from './WaitingRoomObserver'
import ZoomMeetingInitializer from './ZoomMeetingInitializer'

configure({ isolateGlobalState: true })

function toggleAudio() {
  const current = localStorage.getItem('zoom_audio_enabled') === 'true'
  localStorage.setItem('zoom_audio_enabled', (!current).toString())
}

function toggleVideo() {
  const current = localStorage.getItem('zoom_video_enabled') === 'true'
  localStorage.setItem('zoom_video_enabled', (!current).toString())
}

const ZoomManager = ({
  token,
  isChecked,
  brand,
  language,
  startDate,
  endDate,
  meetingNumber,
  passWord,
  userRole,
}: {
  token: string
  isChecked: boolean
  brand: string
  language: string
  startDate: string
  endDate: string
  meetingNumber: string
  passWord: string
  userRole: number
}) => {
  const [isButtonVisible, setIsButtonVisible] = useState(false)

  useEffect(() => {
    setIsButtonVisible(true)
  }, [])
 
  return (
    <div className="flex justify-center items-center">
      <div className="flex justify-center items-center relative">
        {!isButtonVisible && (
          <button
            className={`mt-6 py-2 px-10  text-[#E6E9EC] rounded-lg ${
              !isChecked ? 'bg-[#89949E]' : 'bg-blue-500'
            }`}
            disabled={!isChecked}
          >
            Aceptar
          </button>
        )}
      </div>

      {isButtonVisible && (
        <>
          <MediaPermissionsChecker />
          <RoleBasedCSS userRole={userRole} />
          <WaitingRoomObserver brand={brand} language={language} />
          <ZoomMeetingInitializer
            token={token}
            brand={brand}
            language={language}
            startDate={startDate}
            endDate={endDate}
            meetingNumber={meetingNumber}
            passWord={passWord}
            userRole={userRole}
          />
        </>
      )}
    </div>
  )
}
export default ZoomManager

